import React, { memo, useState } from "react";
import "moment-timezone";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import { getShortBetType } from "../../../utils/tickets/printUtils";
import RefreshButton from "../../../utils/RefreshButton";
import { fetchRouletteRecentDraw } from "../../../store/roulette/action";

const DrawResult = ({ t, lastDraws = [], fetchRouletteRecentDraw }) => {
    const [imageResultRotate, setImageResultRotate] = useState("");

    const handleRefresh = () => {
        setImageResultRotate("rotate");

        Promise.resolve(fetchRouletteRecentDraw({ query: "?size=3&page=1" }))
            .finally(() => {
                setTimeout(() => {
                    setImageResultRotate("");
                }, 300);
            });
    };

    if (!lastDraws.length) {
        return null;
    }

    return (
        <>
            <div className="col no-padding-div header-div-title header-text header-div-blue-light block-header">
        <span className="text-black kh-font-bold">
          {t("labels:common.lastGame")}
        </span>

                <RefreshButton
                    onClick={handleRefresh}
                    className={imageResultRotate}
                />
            </div>

            <div className="col no-padding-div header-div-title header-text header-div-white">
                <table className="table fade-in">
                    <tbody>
                    {lastDraws.map((item, index) => {
                        const {
                            drawLabel,
                            drawCode,
                            underOverCode,
                            oddEvenCode,
                            colorCode,
                            numberCode,
                        } = item;

                        return (
                            <tr
                                className="fade-in table-draw-result"
                                key={drawCode || `${drawLabel}-${index}`}
                            >
                                <td className="text-left font-weight-bold w-last-draw">
                                    {drawLabel}
                                </td>

                                <td className="text-left">
                    <span
                        className={
                            "kh-font-bold left-bet-type-roulette-" + underOverCode
                        }
                    >
                      {t(
                          "labels:betPrefix.S_" +
                          getShortBetType(underOverCode)
                      )}
                    </span>

                                    <span> | </span>

                                    <span
                                        className={
                                            "kh-font-bold left-bet-roulette left-bet-type-" +
                                            oddEvenCode
                                        }
                                    >
                      {t("labels:drawing.drawPrefix." + oddEvenCode)}
                    </span>

                                    <span> | </span>

                                    <span
                                        className={
                                            "kh-font-bold left-bet-roulette bg-oe-" + colorCode
                                        }
                                    >
                      {t("labels:drawing.drawPrefix." + colorCode)}
                    </span>

                                    <span> | </span>
                                    <b className="ff-batt">{numberCode}</b>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

const mapDispatchToProps = {
    fetchRouletteRecentDraw,
};

export default withTranslation()(
    connect(null, mapDispatchToProps)(memo(DrawResult))
);